import { StateCreator, create } from 'zustand';
import { ApolloClient } from '@apollo/client';

import { type ApolloClientConfig } from '../types';
import { apolloClientFactory } from '../apollo/client';
import { useAuthStore } from './authStore';
export interface ApolloState {
  apolloClient?: ApolloClient<unknown>;
  apolloClientError?: Error;
  initializeApolloClient: () => Promise<unknown>;
  apolloLoading: boolean;
}

const createApolloSlice =
  (config: ApolloClientConfig): StateCreator<ApolloState> =>
  (set, get) => {
    return {
      apolloClient: undefined,
      apolloLoading: true,
      apolloClientError: undefined,
      initializeApolloClient: () => {
        return new Promise((resolve, reject) => {
          config.logger.debug('Apollo client 👀');
          const auth = useAuthStore((state) => {
            return state.auth;
          });

          if (!auth) {
            const error = new Error('Auth Not Initialized');
            set({ apolloLoading: false, apolloClientError: error });
            return reject(error);
          }

          try {
            const apolloClient = apolloClientFactory(auth.getAccessTokenSilently, config);
            set({ apolloClient: apolloClient, apolloLoading: false });
            if (!auth.isAuthenticated) {
              config.logger.debug('Apollo anonymous client  ☑️');
            } else {
              config.logger.debug('Apollo authenticated client  ✅');
            }
            return resolve(apolloClient);
          } catch (error: unknown) {
            set({ apolloLoading: false, apolloClientError: error as Error });
            return reject(error);
          }
        });
      },
    };
  };

export const createApolloStore = (config: ApolloClientConfig) => {
  return create<ApolloState>()((...a) => ({
    ...createApolloSlice(config)(...a),
  }));
};
